import React, { Component } from 'react'
import { Col, Row } from 'react-bootstrap'

/**
 * Basic component providing a styling and responsive wrapper for calculator
 * section navigation buttons
 */
export default class NavBar extends Component {
  render () {
    const btnContainerStyle = {
      paddingTop: 22
    }

    return (
      <Row>
        <Col xs={0} sm={1} />
        <Col xs={12} sm={10} md={8} lg={8} style={btnContainerStyle}>
          {this.props.children}
        </Col>
        <Col xs={0} sm={1} md={3} lg={3} />
      </Row>
    )
  }
}



// WEBPACK FOOTER //
// ./src/components/sections/NavBar.js